export enum CoverageCode {
  uLife = 'uLife',
  uLifeIncome = 'uLifeIncome',
  uTraumaA = 'uTraumaA',
  uTPDonTraumaA = 'uTPDonTraumaA',
  uTraumaS = 'uTraumaS',
  uTPDonTraumaS = 'uTPDonTraumaS',
  uTraumaA_MD = 'uTraumaA_MD',
  uTPDonTraumaA_MD = 'uTPDonTraumaA_MD',
  uTraumaS_MD = 'uTraumaS_MD',
  uTPDonTraumaS_MD = 'uTPDonTraumaS_MD',
  uCompDisA = 'uCompDisA',
  uCompDisS = 'uCompDisS',
  uIncome = 'uIncome',
  uLOE = 'uLOE',
  uMRepaymentCov = 'uMRepaymentCov',
  uRedundancy = 'uRedundancy',
  uSpecificInjury = 'uSpecificInjury',
  uPremium = 'uPremium',
  uTraumaChild = 'uTraumaChild',

  AEBLife = 'AEBLife',
  AEBTraumaA = 'AEBTraumaA',
  AEBTraumaS = 'AEBTraumaS',
  AEBCompDisA = 'AEBCompDisA',
  AEBSpecInjury = 'AEBSpecInjury',
  AEBPremCover = 'AEBPremCover',
  mLife = 'mLife',
  mtraumaS = 'mtraumaS',
  mExpensesCov = 'mExpensesCov',
  mPremCover = 'mPremCover',
  FuneralCover = 'FuneralCover',
}
